/**
 * 결제 거래 조회 훅
 * FSD: features/subscription/payment-history/hooks
 */

import { useQuery } from "@tanstack/react-query";
import { transactionAPI } from "../api/transaction-api";

export const useTransactions = () => {
  return useQuery({
    queryKey: ["transactions"],
    queryFn: () => transactionAPI.getUserTransactions(),
    staleTime: 60 * 1000, // 1분
  });
};
